<div class="row">
  <div class="col">
    <div edsGrid>
      <eds-title
        [title]="content.title"
        size="h3"
        theme="dark"
        edsSpacing="lg"
      ></eds-title>
      <div
        edsSubGrid="layout-1"
        edsSubGridTablet="layout-1"
        edsSubGridTabletGap="sm"
        edsSubGridGap="sm"
      >
        <ng-container
          *ngFor="let avatar of content.profilesItems; let i = index"
        >
          <eds-avatar
            [title]="avatar.fullName"
            [text1]="avatar.overview"
            [emailId]="avatar.email"
            [imgSrc]="avatar.profileImageUrl"
            fallbackImgSrc="/assets/images/ben_head.png"
            [href]="avatar.profileLink"
            [scheduleAppointmentText]="appointmentText"
            [scheduleAppointmentUrl]="appointmentUrl"
            edsSpacing="lg"
            [signInRequired]="signInRequired | ftIsSignInRequired | async"
          >
          </eds-avatar>
        </ng-container>
      </div>
    </div>
  </div>
</div>
